"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseHomePage = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMediaQueryHoc = require("react-media-query-hoc");
var _listing = _interopRequireDefault(require("../../models/listing"));
var _largeCard = _interopRequireDefault(require("../../components/large-card"));
var _overlayCard = _interopRequireDefault(require("../../components/overlay-card"));
var _smallCard = _interopRequireDefault(require("../../components/small-card"));
var _horizontalSlide = _interopRequireDefault(require("../../components/horizontal-slide"));
var _shadowFrame = _interopRequireDefault(require("../../components/shadow-frame"));
var styles = _interopRequireWildcard(require("./home-page.style"));
var _core = require("@emotion/core");
var _excluded = ["media"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var withShadow = media => Component => props => media.desktop ? (0, _core.jsx)(_shadowFrame.default, null, (0, _core.jsx)(Component, props)) : (0, _core.jsx)(Component, props);
var getCardComponent = _ref => {
  var media = _ref.media,
    listings = _ref.listings;
  if (media.mobile) {
    return _smallCard.default;
  }
  if (listings.length === 1) {
    return withShadow(media)(_largeCard.default);
  }
  return withShadow(media)(props => (0, _core.jsx)(_overlayCard.default, _extends({
    size: listings.length === 2 ? 'large' : 'small'
  }, props)));
};
var HomePage = _ref2 => {
  var media = _ref2.media,
    props = _objectWithoutProperties(_ref2, _excluded);
  var ListingCard = getCardComponent({
    media,
    listings: props.listings
  });
  return (0, _core.jsx)("div", {
    css: styles.container
  }, media.mobile && (0, _core.jsx)("h2", {
    css: styles.title
  }, props.title), (0, _core.jsx)(_horizontalSlide.default, _extends({
    noScroll: media.desktop,
    component: ListingCard
  }, props)));
};
exports.BaseHomePage = HomePage;
HomePage.propTypes = {
  listings: _propTypes.default.arrayOf(_propTypes.default.shape(_listing.default)),
  onClick: _propTypes.default.func,
  title: _propTypes.default.string,
  media: _propTypes.default.shape({
    mobile: _propTypes.default.bool,
    desktop: _propTypes.default.bool
  })
};
HomePage.defaultProps = {
  listings: [],
  onClick: () => {},
  title: 'Property of the Week',
  media: {}
};
var _default = exports.default = (0, _reactMediaQueryHoc.withMedia)(HomePage);